<template>
  <div style="padding: 0.22rem">
    <div>
      <div class="left_title">需求管理</div>
      <div
        @click="leftGoto('/requirementManagement')"
        class="left_tab"
        :class="
          left_tabShow == 'requirement_management' ? 'left_tab_select' : ''
        "
      >
        参与的需求
      </div>
      <div
        @click="leftGoto('/requirementPublish')"
        class="left_tab"
        :class="left_tabShow == 'requirement_publish' ? 'left_tab_select' : ''"
      >
        发布的需求
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
const router = useRouter();

defineProps({
  left_tabShow: String,
});
//直接跳转
const leftGoto = (type) => {
  console.log("dianji ", type);
  router.push(type);
};
</script>

<style scoped>
.left_title {
  font-size: 0.18rem;
  margin-bottom: 0.2rem;
  color: #86909c;
}

.left_tab {
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
  color: #333333;
  cursor: pointer;
}

.left_tab_select {
  color: #C01A26;
}
</style>
